import { render, staticRenderFns } from "./input-barcode.vue?vue&type=template&id=664c5636&scoped=true"
import script from "./input-barcode.vue?vue&type=script&lang=tsx"
export * from "./input-barcode.vue?vue&type=script&lang=tsx"
import style0 from "./input-barcode.vue?vue&type=style&index=0&id=664c5636&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664c5636",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664c5636')) {
      api.createRecord('664c5636', component.options)
    } else {
      api.reload('664c5636', component.options)
    }
    module.hot.accept("./input-barcode.vue?vue&type=template&id=664c5636&scoped=true", function () {
      api.rerender('664c5636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ops/input-barcode.vue"
export default component.exports